export const FETCH_DISH_TYPES = {
  START: 'START_FETCH_DISH_TYPES',
  COMPLETE: 'COMPLETE_FETCH_DISH_TYPES',
  FAIL: 'FAIL_FETCH_DISH_TYPES',
  CLEANUP: 'CLEANUP_FETCH_DISH_TYPES',
}

export const ADD_DISH_TYPE = 'ADD_DISH_TYPE'
export const RENAME_DISH_TYPE = 'RENAME_DISH_TYPE'
export const RESET_DISH_TYPE_TREE = 'RESET_DISH_TYPE_TREE'

export const SET_DATA_FOR_RENAMING_DISH_TYPE = 'SET_DATA_FOR_RENAMING_DISH_TYPE'

export const SET_IS_CURATION_ENABLED_DISH_TYPE = {
  START: 'START_SET_IS_CURATION_ENABLED_DISH_TYPE',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_DISH_TYPE',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_DISH_TYPE',
}

export const REPLACE_DISH_TYPE = {
  START: 'START_REPLACE_DISH_TYPE',
  COMPLETE: 'COMPLETE_REPLACE_DISH_TYPE',
  FAIL: 'FAIL_REPLACE_DISH_TYPE',
}

export const REVERT_REPLACE_DISH_TYPE = {
  START: 'START_REVERT_REPLACE_DISH_TYPE',
  COMPLETE: 'COMPLETE_REVERT_REPLACE_DISH_TYPE',
  FAIL: 'FAIL_REVERT_REPLACE_DISH_TYPE',
}

export const DELETE_DISH_TYPE = {
  START: 'START_DELETE_DISH_TYPE',
  COMPLETE: 'COMPLETE_DELETE_DISH_TYPE',
  FAIL: 'FAIL_DELETE_DISH_TYPE',
}

export const MOVE_DISH_TYPES = 'MOVE_DISH_TYPES'

export const SAVE_DISH_TYPES = {
  START: 'START_SAVE_DISH_TYPES',
  COMPLETE: 'COMPLETE_SAVE_DISH_TYPES',
  FAIL: 'FAIL_SAVE_DISH_TYPES',
}

export const EXPAND_DISH_TYPE_MAIN_TREE_KEYS = 'EXPAND_DISH_TYPE_MAIN_TREE_KEYS'

export const EXPAND_DISH_TYPE_SUPPORTING_TREE_KEYS =
  'EXPAND_DISH_TYPE_SUPPORTING_TREE_KEYS'
